export default "__VITE_ASSET__sHohrsNy__"